<div class="card h-100 d-flex flex-column">
  <div class="card-header bg-white border-bottom d-flex align-items-center justify-content-between">
    <h6 class="mb-0">Identity Detection Trend (30 Days)</h6>
    <kendo-dropdownbutton
      kendoButton
      [svgIcon]="moreVerticalIcon"
      fillMode="flat"
      size="small"
      [data]="menuItems"
      (itemClick)="onMenuSelect($event)"
    ></kendo-dropdownbutton>
  </div>
  <div class="card-body d-flex flex-column flex-grow-1">
    @if (isLoading()) {
      <div class="d-flex justify-content-center align-items-center py-5">
        <div
          class="spinner-border spinner-border-sm text-primary"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else if (hasNoData()) {
      <div class="d-flex flex-column justify-content-center align-items-center text-muted flex-grow-1" style="min-height: 200px">
        <div class="mb-1">Detections not available yet</div>
      </div>
    } @else {
      <div
        echarts
        [options]="chartOptions()"
        class="flex-grow-1"
        style="min-height: 200px"
      ></div>
    }
  </div>
</div>
